module.exports = __webpack_public_path__ + "img/austria-endocrine-nutritional-metabolic-diseases-male.ea37714e.png";